import { OptionsType } from '@openx/types/options.ts';
import type { SelectRateFormState } from '@openx/types/targeting/selectRate.ts';
import { TargetingFields, type TargetingProps } from '@openx/types/targeting/targeting.ts';
import { noop } from '@openx/utils/noop.ts';
import { useTranslation } from 'react-i18next';
import { viewThroughRateTierLabel } from '../shared/SelectRate/constants.ts';
import { SelectRate } from '../shared/SelectRate/SelectRate.tsx';

export function ViewThroughRate({
  targetingParams,
  onFieldUpdate = noop,
  name,
  readonly,
}: TargetingProps<SelectRateFormState>) {
  const { t } = useTranslation();

  return (
    <SelectRate
      targetingParams={targetingParams}
      onFieldUpdate={onFieldUpdate}
      name={name}
      readonly={readonly}
      field={TargetingFields.VIEW_THROUGH_RATE}
      placeholder={viewThroughRateTierLabel}
      filterTitle={viewThroughRateTierLabel}
      optionsFetch={OptionsType.VIEW_THROUGH_RATE}
      dataTest="view-through-rate"
      description={t(
        'Target inventory with historically similar video completion rates to align with campaign performance goals. Not applicable for CTV deals.'
      )}
    />
  );
}
